var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-height":"300px"}},[(_vm.src)?_c('video',{ref:"video",attrs:{"width":"100%","height":"100%","controls":"","playsinline":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }